import { Link } from "react-router-dom";

import dd from "../../assets/DD.png";
import ar from "../../assets/Ar.png";

const DropdownMenu = ({
  title,
  items,
  openDropdown,
  toggleDropdown,
  handleLinkClick,
}) => {
  return (
    <div className="relative">
      <div className="flex items-center gap-1">
        <a
          href="#"
          className="text-black hover:text-black flex items-center"
          onClick={(e) => {
            e.preventDefault();
            toggleDropdown(title.toLowerCase());
          }}
        >
          {title}
          <img
            src={dd}
            alt="Dropdown arrow"
            className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
              openDropdown === title.toLowerCase() ? "rotate-180" : "rotate-0"
            }`}
          />
        </a>
      </div>

      {openDropdown === title.toLowerCase() && (
        <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
          {items.map((item) =>
            item.external ? (
              <a
                key={item.to}
                href={item.to}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
                className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
              >
                <span className="ml-2 text-xs">{item.label}</span>
                <img
                  src={ar}
                  alt="Right arrow"
                  className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </a>
            ) : (
              <Link
                key={item.to}
                to={item.to}
                onClick={handleLinkClick}
                className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
              >
                <span className="ml-2 text-xs">{item.label}</span>
                <img
                  src={ar}
                  alt="Right arrow"
                  className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </Link>
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
